module.exports = __webpack_public_path__ + "static/img/5927_phase_function_Paper_PointsHejduk_Prediction.45029ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5927_phase_function_Paper_PointsHejduk_Prediction.png
// module id = oxuB
// module chunks = 0